export default{
    globalMgmt: {
        global: "Global Customer Management",
        alarms: "Alarm Definitions",
        history: "History",
        alarmPageTitle: "Global Alarm Definitions",
        alarmDetails: "Alarm Details"
    }
}
